<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :form-fields="{model: []}"
                      :url="url"
                      :permission="{}"
                      :operate="[]"
                      :buttons="buttons"
                      :searchs="searchs"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";

    export default {
        name: "ExportTask",
        components: {CommonTable},
        data() {
            return {
                form: {
                    startTime: '',
                    endTime: '',
                    agentId: '',
                },
                agents: [],
                searchs:[{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'type',
                    placeholder: '请选择类型',
                    type: 'select',
                    selectValue:[{
                        key: 1,
                        value: "会员充值"
                    }, {
                        key: 2,
                        value: "会员提现"
                    }, {
                        key: 3,
                        value: "会员列表"
                    }, {
                        key: 4,
                        value: "积分记录"
                    }, {
                        key: 5,
                        value: "积分充值"
                    }, {
                      key: 8,
                      value: "自动发布"
                    }]
                }, {
                    name: 'status',
                    placeholder: '请选择状态',
                    type: 'select',
                    selectValue:[{
                        key: 0,
                        value: "失败"
                    }, {
                        key: 1,
                        value: "成功"
                    }, {
                        key: 2,
                        value: "进行中"
                    }]
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                url: {
                    get: '/exportTask/listByCondition',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'content',
                    label: '条件',
                    show: true,
                    width: '',
                }, {
                    field: 'url',
                    label: '链接',
                    show: true,
                    width: '',
                }, {
                    field: 'type',
                    label: '类型',
                    show: {
                        type: 'select',
                    },
                    selectData: [{
                        id: 1,
                        name: '会员充值'
                    }, {
                        id: 2,
                        name: '会员提现'
                    },{
                        id: 3,
                        name: '会员列表'
                    }, {
                        id: 4,
                        name: '积分记录'
                    }, {
                        id: 5,
                        name: '积分充值'
                    }, {
                      id: 6,
                      name: '充值提现统计'
                    }, {
                      id: 7,
                      name: '团队信息'
                    }, {
                      id: 8,
                      name: '自动发布'
                    }],
                    width: '',
                }, {
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'select',
                    },
                    selectData: [{
                        id: 0,
                        name: '失败'
                    }, {
                        id: 1,
                        name: '成功'
                    }, {
                        id: 2,
                        name: '进行中'
                    },],
                    width: '',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }]
            }
        }
    }
</script>

<style scoped>

</style>
